import axios from 'axios';

export const createPreviewApiClient = () => {
  const hostname = window.location.hostname;
  let apiBaseUrl: string;

  if (import.meta.env.VITE_API_BASE_URL) {
    apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  } else if (hostname.includes('localhost') || hostname.includes('compete-pages-local.com')) {
    apiBaseUrl = 'http://localhost:3001';
  } else {
    apiBaseUrl = 'https://compete-pages-api.vercel.app';
  }

  return axios.create({
    baseURL: apiBaseUrl,
    timeout: 10000,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('authToken')}`,
    },
  });
};
